/* cb-gift-progress — free-gift progress bar for the cart drawer + cart page.
   Fed by cb-alia-gift-add's `cb-gift:state` events / window.__cbGiftState.
   Shadow DOM (no theme CSS bleed). JS-mounted, MutationObserver re-mounts
   after Horizon's morphSection wipes injected nodes. No core file edits.
   REVERSIBLE: delete this asset + the loader line in cb-alia-gift-add. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  if (customElements.get('cb-gift-progress')) return;

  var GIFT_NAME = 'FREE Glutamine 250g';
  var GIFT_VALUE = '$24.95';

  class CbGiftProgress extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;
      var root = this.attachShadow({ mode: 'open' });
      root.innerHTML =
        '<style>' +
        ':host { display:none; font-family: Inter, ui-sans-serif, system-ui, sans-serif; }' +
        '.wrap { background:var(--lk-f6f6f6, #f6f6f6); border:1px solid rgba(0,0,0,0.06); border-radius:10px; padding:10px 14px; margin:10px 12px; }' +
        '.msg { font-size:13px; line-height:1.35; color:var(--lk-393076, #393076); font-weight:600; margin:0 0 7px; }' +
        '.msg b { color:var(--lk-00bfff, #00bfff); }' +
        '.msg .val { color:var(--lk-727272, #727272); font-weight:500; }' +
        '.track { height:8px; border-radius:999px; background:var(--lk-e2e2e2, #e2e2e2); overflow:hidden; }' +
        '.fill { height:100%; border-radius:999px; background:linear-gradient(90deg,var(--lk-00bfff, #00bfff),var(--lk-393076, #393076)); width:0%; transition:width .45s ease; }' +
        '.wrap.unlocked { background:rgba(0,191,255,0.07); border-color:rgba(0,191,255,0.35); }' +
        '.wrap.unlocked .track { display:none; }' +
        '</style>' +
        '<div class="wrap"><p class="msg"></p><div class="track"><div class="fill"></div></div></div>';
      this._wrap = root.querySelector('.wrap');
      this._msg = root.querySelector('.msg');
      this._fill = root.querySelector('.fill');
      this.render(window.__cbGiftState || { mode: 'hidden' });
    }
    render(state) {
      if (!this._wrap) return;
      if (!state || state.mode === 'hidden') { this.style.display = 'none'; return; }
      this.style.display = 'block';
      if (state.mode === 'unlocked') {
        this._wrap.classList.add('unlocked');
        this._msg.innerHTML = '🎁 <b>' + GIFT_NAME + '</b> added to your cart — <b>$0.00</b> <span class="val">(' + GIFT_VALUE + ' value)</span>';
      } else {
        this._wrap.classList.remove('unlocked');
        var rem = '$' + (state.remainingCents / 100).toFixed(2);
        this._msg.innerHTML = 'You’re <b>' + rem + '</b> away from your ' + GIFT_NAME + ' <span class="val">(' + GIFT_VALUE + ')</span>';
        this._fill.style.width = (state.pct || 0) + '%';
      }
    }
  }
  customElements.define('cb-gift-progress', CbGiftProgress);

  /* Mount points: top of drawer items + above cart page summary. */
  var ANCHORS = [
    { host: 'cart-drawer-component .cart-drawer__items', where: 'before' },
    { host: '.cart-page__summary', where: 'before' }
  ];

  function mountAll() {
    ANCHORS.forEach(function (a) {
      var host = document.querySelector(a.host);
      if (!host) return;
      var parent = host.parentNode;
      if (!parent || parent.querySelector('cb-gift-progress')) return;
      var el = document.createElement('cb-gift-progress');
      parent.insertBefore(el, host);
      el.render && el.render(window.__cbGiftState || { mode: 'hidden' });
    });
  }

  function renderAll(state) {
    document.querySelectorAll('cb-gift-progress').forEach(function (el) {
      el.render && el.render(state);
    });
  }

  document.addEventListener('cb-gift:state', function (e) { mountAll(); renderAll(e.detail); });

  var moDebounce = null;
  try {
    new MutationObserver(function () {
      clearTimeout(moDebounce);
      moDebounce = setTimeout(function () { mountAll(); renderAll(window.__cbGiftState || { mode: 'hidden' }); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
})();
